module.exports = __webpack_public_path__ + "img/dash2.d9baeb9f.webp";